<template>
    <div style="margin-top: 24px;">
        <div>
            <!-- <div style="font-size: 32px; font-weight: 700; line-height: 46px; text-align: center;">실력을 알려주세요</div> -->
            <div style="margin-top: 20px;">
                <div class="title">실력</div>
                <div class="common_box_wrap">
                    <div v-for="each, i in skill" :key="i" @click='setSelectSkill(each.id)' :style="{backgroundColor: each.id === selectedSkill ? 'var(--color-main)' : '#fff'}" class="common_box_circle">
                        <div class="common_text">{{ each.title }}</div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 32px;">
                <div class="title">구력</div>
                <div class="common_box_wrap">
                    <div v-for="each, i in lengthOfPlay" :key="i + 'lengthOfPlay'" @click='setSelectLengthOfPlay(each.id)' :style="{backgroundColor: each.id === selectedLengthofPlay ? 'var(--color-main)' : '#fff'}" class="common_box">
                        <div class="common_text">{{ each.title }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { REGIST_STEP } from '@/Constants';

export default {
    name: 'SignupSkill',
    props: {
        selectedSkill: {
            type: String,
            default: ''
        },
        selectedLengthofPlay: {
            type: String,
            default: ''
        },
        setSelectSkill: {
            type: Function,
            default: () => {}
        },
        setSelectLengthOfPlay: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            skill: [
                {title: '하🔻', id: '하'},
                {title: '중하', id: '중하'},
                {title: '중', id: '중'},
                {title: '중상', id: '중상'},
                {title: '상🔺', id: '상'},
            ],
            lengthOfPlay: [
                {title: '1년 미만', id: '1년 미만'},
                {title: '1~2년', id: '1~2년'},
                {title: '2~5년', id: '2~5년'},
                {title: '5~9년', id: '5~9년'},
                {title: '10년 이상', id: '10년 이상'},
            ],
        }
    },
    methods: {

    },
}
</script>

<style scoped>
.title {
    margin-bottom: 16px;
    font-weight: 500;
}

.common_box_wrap {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.common_box {
    width: 110px;
    text-align: center;
    padding: 8px;
    border: 1px solid #d9d9d9;
    border-radius: 12px;
}

.common_box_circle {
    border: 1px solid #d9d9d9;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.common_text {
    font-weight: 500;
    line-height: 24px;
    white-space: nowrap;
}
</style>